(function (root) {
  'use strict';
  const API = {
    total(price, quantity) {
      if (!Number.isInteger(price) || price < 0) throw new Error('Precio inválido');
      if (![1, 2, 3].includes(quantity)) throw new Error('Cantidad inválida');
      // Connector configures the discount to this target; never round display only.
      return quantity === 1 ? price : API.price95(quantity === 2 ? price * 1.5 : price * 2);
    },
    price95(cents) {
      if (!Number.isFinite(cents) || cents <= 0) throw new Error('Precio inválido');
      return Math.max(95, Math.round((cents - 95) / 100) * 100 + 95);
    },
    compare(price) { return API.price95(price * 2); },
    discount(price, quantity) { return price * quantity - API.total(price, quantity); },
    tier(price) { return price < 1000 ? 'T1' : price < 2000 ? 'T2' : price < 3000 ? 'T3' : 'T4'; },
    remaining(deadline, now) { return Math.max(0, Math.ceil((deadline - now) / 1000)); },
    clock(seconds) {
      return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(v => String(v).padStart(2, '0')).join(' : ');
    },
    shipping(original) { return original < 1000 ? 199 : original < 2000 ? 395 : original < 4000 ? 495 : original <= 8000 ? 695 : 795; },
    adjusted(original) { return original < 1000 ? 795 : API.price95(original - API.shipping(original)); },
    offer(original, quantity) {
      const unit=API.adjusted(original), shipping=quantity===3?0:API.shipping(original);
      return {unit, merchandise:API.total(unit,quantity), shipping, total:API.total(unit,quantity)+shipping};
    },
    shippingThreshold(prices, protectionFee) {
      const minimumThree = Math.min(...prices.map(q => API.total(q,3)));
      const maximumPaid = Math.max(...prices.map(q => API.total(q,2)+protectionFee));
      return maximumPaid < minimumThree ? minimumThree : null;
    },
    ebookPlan(cart, mainProductId, ebookProductId, ebookVariantId) {
      const main=cart.items.filter(i=>String(i.product_id)===String(mainProductId));
      const gifts=cart.items.filter(i=>String(i.product_id)===String(ebookProductId));
      const wanted=main.reduce((n,i)=>n+i.quantity,0)>=2;
      const updates={};let kept=false;
      for(const item of gifts){
        const keep=wanted&&!kept&&String(item.variant_id)===String(ebookVariantId);
        if(keep&&item.original_price!==0)throw new Error('El ebook debe tener precio cero.');
        const quantity=keep?1:0;
        if(quantity!==item.quantity)updates[item.key]=quantity;
        if(keep)kept=true;
      }
      return {updates,add:wanted&&!kept?ebookVariantId:null,wanted};
    },
    protectionPlan(cart, productId, variants, optIn, excludeProductIds = [], policy = {}) {
      const protection = cart.items.filter(i => String(i.product_id) === String(productId));
      const merchandise = cart.items.filter(i => String(i.product_id) !== String(productId) && !excludeProductIds.some(id => String(id) === String(i.product_id)));
      const unit = Math.max(0, ...merchandise.map(i => Number(policy[String(i.variant_id)]?.reference_price) || i.original_price));
      const variant = variants.find(v => (v.sku === 'GOD-PROTECTION-' + API.tier(unit) || v.option1 === API.tier(unit)) && v.available);
      const wanted = Boolean(optIn && merchandise.length);
      if (wanted && !variant) throw new Error('No está disponible la tarifa de protección correspondiente.');
      const updates = {};
      let kept = false;
      for (const item of protection) {
        const keep = wanted && !kept && String(item.variant_id) === String(variant.id);
        const quantity = keep ? 1 : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
        if (keep) kept = true;
      }
      return {updates, add: wanted && !kept ? variant.id : null, wanted};
    }
  };
  root.GodCore = API;
  if (typeof module !== 'undefined') module.exports = API;
})(typeof globalThis !== 'undefined' ? globalThis : window);
